import React from 'react'
import App from './App'
import { createHttpLink, ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client'
import { setContext } from "apollo-link-context";
const httpLink = createHttpLink({
    uri: 'https://sync-with-me.herokuapp.com/'
})


const authLink = setContext(() => {
    const token = localStorage.getItem('jwtToken');
    return {
        headers: {
            Authorization: token ? `Bearer ${token}` : ''
        }
    }
})

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    // connectToDevTools: false
})


export default (
    <ApolloProvider client={client}>
        <App />
    </ApolloProvider>
)